import React from 'react';
import styled from 'styled-components';
import { Collapse } from 'antd';
import DownArrowIcon from "assets/icons/down-arrow-icon";
import UpArrowIcon from "components/up-arrow-icon";
import { COLOR } from 'constants/colors';
import { Tag } from 'antd';
import moment from 'moment';
import { AGENT_STATUS } from 'constants/common-constants';

const SiteAccordionCont = styled.div`
.site-collapse-custom-panel{
    font-size: 16px;
    font-weight: 500;
    padding-bottom:16px;
}
.site-collapse-custom{
    font-size: 14px;
    font-weight: 400;
}
.ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 12px 0;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding-top: 0px;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding-bottom: 0
}
.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding-top: 0
}
.ant-tag{
    color: #F5AE0A;
    background: #f5f5f5;
    border: none;
    border-radius: 10px;
    margin: 4px 0 16px 0; 
    font-size: 14px;
    font-weight: 400;
}
`;

const LightText = styled.p`
    color: #a1a6a7;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.8;
`;
const SiteCollapseCustom = styled.div`
    font-size: 14px;
    font-weight: 400;
`;
const DarkText = styled.span`
    color: ${COLOR.BOLD_GRAY};
    font-size: 14px;
    font-weight: 400;
    color: #121617;
    line-height: 1.8;
`;

interface AccordionProps {
    key: number;
    accordionItem?: any;
    onCancelPlan?: (stpItem: any) => void;
    footerBtn?: JSX.Element;
}

const SiteAccordion: React.FC<AccordionProps> = (props: AccordionProps) => {
    const { Panel } = Collapse;
    const { accordionItem } = props;
    const freqObject: any = { 1: "Monthly", 3: "Quarterly", 6: "Half yearly", 12: "Yearly", 30: "Daily", 52: "Weekly" };
    const freqType = accordionItem?.investmentFrequency;

    return (<SiteAccordionCont>
        <Collapse
            style={{ padding: "0", background: "#fff" }}
            bordered={false}
            expandIcon={({ isActive }) => isActive ? <UpArrowIcon /> : <DownArrowIcon />}
            expandIconPosition="right"
            defaultActiveKey={0}>
            <Panel key="1" className="site-collapse-custom-panel"
                header={<div>
                    <p>{accordionItem?.noOfInstallments} {freqObject[freqType]} {accordionItem?.investmentType === "STP" ? 'transfers' : 'withdrawals'} of ₹ {accordionItem?.installmentAmt?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</p>
                    {accordionItem?.agentStatus === AGENT_STATUS.ACTIVE && <Tag style={{ color: `${COLOR.GREEN}` }}>Active</Tag>}
                    {accordionItem?.agentStatus === AGENT_STATUS.PENDINGVERIFICATION && <Tag style={{ color: `${COLOR.RED}` }}>Email Verification Pending</Tag>}
                    {accordionItem?.agentStatus === AGENT_STATUS.PENDING.toUpperCase() && <Tag color="default">Awaiting Approval</Tag>}
                    {accordionItem?.agentStatus === AGENT_STATUS.APPROVED.toUpperCase() && <Tag style={{ color: `${COLOR.BLUE}` }}>Approved</Tag>}
                    {accordionItem?.agentStatus === AGENT_STATUS.AUTOCANCELLED && <Tag style={{ color: `${COLOR.GREY3}` }}>Verification Link Expired</Tag>}
                    <LightText>From:&nbsp;<DarkText style={{ textTransform: 'capitalize' }}> {accordionItem?.fromSchemeName?.toLowerCase()}</DarkText></LightText>
                    {accordionItem?.toSchemeName && <LightText>To:&nbsp;<DarkText style={{ textTransform: 'capitalize' }}> {accordionItem?.toSchemeName?.toLowerCase()}</DarkText></LightText>}
                </div>}
            >
                <SiteCollapseCustom>
                    <LightText>Start Date:&nbsp;<DarkText>{moment(accordionItem?.startDate).format('DD/MM/YYYY')}</DarkText></LightText>
                    {accordionItem?.endDate && <LightText>End Date:&nbsp;<DarkText> {moment(accordionItem?.endDate).format('DD/MM/YYYY')}</DarkText></LightText>}
                    <LightText>Frequency of Transfer:&nbsp;<DarkText>{freqObject[freqType]}</DarkText></LightText>
                    { accordionItem?.noOfInstallments && <LightText>No. of Installments:&nbsp;<DarkText> {accordionItem?.noOfInstallments}</DarkText></LightText>}
                    <br />
                    {
                        props?.footerBtn
                    }
                </SiteCollapseCustom>
            </Panel>
        </Collapse>
    </SiteAccordionCont>)
}

export default SiteAccordion;